<template>
		<section id="article">
			<div class="container list-item section-active">
				<div class="row">
					<div class="col-xs-12 col-sm-12 col-md-12 article-list" @click="noneSearchList()">
						<div class="col-xs-12 col-sm-4 col-md-4" v-for="(item, index) of articleData" :key="index" @click="handleToContentDetail(item.id)">
							<div class="information-item">
								<!-- <div v-if="item.image" class="article-img" :style="'background-image: url('+item.image+');'"></div> -->
								<div class="information-content">
									<p class="ic-title">{{item.title}}</p>
									<p class="ic-author">{{item.author}}</p>
									<p class="ic-detail">{{item.content}}</p>
									<p class="ic-read">
										<span>READ</span>
										<span class="iconfont">&#xe610;</span>
									</p>
								</div>
							</div>
						</div>
					</div>
					<div class="col-xs-12 col-sm-12 col-md-12 find-more text-align-center" @click="handleToFindMore()">
						{{more}}&nbsp;<label class="icon iconfont" style="font-weight:bold" v-if="more=='点击查看更多'"> &#xe612;</label>
					</div>
				</div>
			</div>
			<div class="container list-item-detail display-none">
				<div class="row">
					<div class="col-xs-12 col-sm-12 col-md-12 article-content-detail">
					</div>
				</div>
			</div>
		</section>
</template>

<script>
export default {
	name: 'article',
	data () {
		return {
			page: 1,
			articleData: [],
			more: '点击查看更多',
			articleMoudle: 'pc',
			searchListDisplay: false,
			searchWords: '',
			searchData: [],
			isTrident: false,
			limit: 6,
		}
	},
	mounted () {
		if ((window.navigator.userAgent).toLocaleLowerCase().indexOf('trident') != -1) {
			this.isTrident = true
		}
		this.getArticleList();
	},
	methods: {
		noneSearchList () {
			this.searchListDisplay = false
		},
		handleToFindMore () {
			this.page++;
			this.getArticleList();
		},
		handleToContentDetail (id) {
			this.searchListDisplay = false
			this.$router.push({ path: '/articleDetail', query: {id: id} })
		},
		getArticleList () {
			this.axios.get('https://sys.qilinsports.com/law/sysarticle/page',{
				params: {page: this.page, limit: this.limit},
			}).then((res) => {
				if (res.data.code == 0) {
					var data = res.data.data;
					if (data.list.length < this.limit) {
						this.more = '没有更多数据了~'
					} else {
						this.more = '点击查看更多'
					}
					if (data.list.length == 0) {
						return;
					}
					var clientWidth = 0
					if (window.innerHeight !== undefined) {
						clientWidth = window.innerWidth;
					} else if (document.compatMode === "CSS1Compat") {
						clientWidth = document.documentElement.clientWidth;
					} else {
						clientWidth = document.body.clientWidth;
					}
					if (clientWidth <= 768) {
						this.articleMoudle = 'yidong'
					} else {
						this.articleMoudle = 'pc'
					} 
					this.articleData = this.articleData.concat(data.list)
					console.log(this.articleData)
				}
			}).catch(function(error){
				console.log(error)//错误处理 相当于error
			})
		}
	}
}
</script>

<style scoped>
@import url("../assets/css/common.css");
@import url("../assets/css/product.css");
</style>


// WEBPACK FOOTER //
// src/components/article.vue